import React from 'react';
import { DatabaseIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function EnrichmentPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-2814">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2815">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2816">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2817">
            Simple pricing for local business data{' '}
            <span className="text-blue-600" data-id="element-2818">enrichment</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2819">
            Enrich local business contacts without enterprise contracts or
            hidden fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2820">
          {/* Enrich Records */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2821">
            <div className="flex items-center gap-3 mb-4" data-id="element-2822">
              <DatabaseIcon className="w-5 h-5 text-slate-400" data-id="element-2823" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2824">
                Enrich local business records
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2825">
              Match and enrich basic local business data with full profiles.
            </p>
            <div data-id="element-2826">
              <div className="flex items-baseline gap-2" data-id="element-2827">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2828">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2829">
                unlimited company enrichments
              </p>
            </div>
          </div>

          {/* Owner Emails */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2830">
            <div className="flex items-center gap-3 mb-4" data-id="element-2831">
              <MailIcon className="w-5 h-5 text-slate-400" data-id="element-2832" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2833">
                Local business owner emails
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2834">
              Find verified email addresses for local business decision-makers.
            </p>
            <div data-id="element-2835">
              <div className="flex items-baseline gap-2" data-id="element-2836">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2837">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2838">
                per 100 emails found
              </p>
            </div>
          </div>

          {/* Employee Phones */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2839">
            <div className="flex items-center gap-3 mb-4" data-id="element-2840">
              <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-2841" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2842">
                Local business employee phones
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2843">
              Get direct dial and mobile numbers for local business contacts.
            </p>
            <div data-id="element-2844">
              <div className="flex items-baseline gap-2" data-id="element-2845">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2846">$24</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2847">
                per 100 phones found
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-2848">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2849">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2850" />
            <span data-id="element-2851">Pay only for valid matches</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2852">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2853" />
            <span data-id="element-2854">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2855">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2856" />
            <span data-id="element-2857">No credit card required</span>
          </div>
        </div>

        <div className="text-center" data-id="element-2858">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-2859">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-2860">
              Try for free
            </a>
          </div>
        </div>
      </div>
    </section>;
}